var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStateApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons set"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7159 16.9739H8.49586C8.08186 16.9739 7.74586 16.6379 7.74586 16.2239C7.74586 15.8099 8.08186 15.4739 8.49586 15.4739H15.7159C16.1299 15.4739 16.4659 15.8099 16.4659 16.2239C16.4659 16.6379 16.1299 16.9739 15.7159 16.9739Z",
    fill: "#082A51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7159 12.7874H8.49586C8.08186 12.7874 7.74586 12.4514 7.74586 12.0374C7.74586 11.6234 8.08186 11.2874 8.49586 11.2874H15.7159C16.1299 11.2874 16.4659 11.6234 16.4659 12.0374C16.4659 12.4514 16.1299 12.7874 15.7159 12.7874Z",
    fill: "#082A51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2506 8.61061H8.49556C8.08156 8.61061 7.74556 8.27461 7.74556 7.86061C7.74556 7.44661 8.08156 7.11061 8.49556 7.11061H11.2506C11.6646 7.11061 12.0006 7.44661 12.0006 7.86061C12.0006 8.27461 11.6646 8.61061 11.2506 8.61061Z",
    fill: "#082A51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9088 3.50021L8.21976 3.50421C5.89176 3.51821 4.49976 4.95821 4.49976 7.35721V16.5532C4.49976 18.9682 5.90476 20.4102 8.25576 20.4102L15.9448 20.4072C18.2728 20.3932 19.6648 18.9512 19.6648 16.5532V7.35721C19.6648 4.94221 18.2608 3.50021 15.9088 3.50021ZM8.25676 21.9102C5.11276 21.9102 2.99976 19.7572 2.99976 16.5532V7.35721C2.99976 4.12421 5.04676 2.02321 8.21476 2.00421L15.9088 2.00021C19.0528 2.00021 21.1648 4.15321 21.1648 7.35721V16.5532C21.1648 19.7852 19.1178 21.8872 15.9498 21.9072L8.25676 21.9102Z",
    fill: "#082A51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStateApplication);
export default __webpack_public_path__ + "static/media/icon-state-application.7e097e727923999dae52baab85c70aea.svg";
export { ForwardRef as ReactComponent };